<template>

  <div class="show-app">

    <Form :app="app" :to-edit="true"/>

    <div class="editor px-3 py-3" :class="{'close-editor': !openEditor}">
      <h3>Editar o APP</h3>

      <div class="form-group">
        <label for="nickname-title">Nome</label>
        <input id="nickname-title" v-model="app.nickname" class="form-control" :class="{empty: !app.nickname}">
      </div>

      <div class="form-group">
        <label for="category-app">Categoria</label>
        <select id="category-app" v-model="app.category" class="form-control" :class="{empty: !app.category}">
          <option value="1abjklja adfakl">1</option>
          <option value="2abjklja adfakl">2</option>
          <option value="3abjklja adfakl">3</option>
        </select>
      </div>

      <div class="form-group">
        <label for="status-app">Status</label>
        <select id="status-app" v-model="app.status" class="form-control" :class="{empty: !app.status}">
          <option value="1abjklja adfakl">1</option>
          <option value="2abjklja adfakl">2</option>
          <option value="3abjklja adfakl">3</option>
        </select>
      </div>

      <div class="form-group">
        <label for="icon-app">Ícone</label>
        <select id="icon-app" v-model="app.icon" class="form-control" :class="{empty: !app.icon}">
          <option v-for="icon in optionsIcon" :key="icon" :value="icon">
            {{ icon }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label>Descrição</label>
        <Editor v-if="openEditor" v-model="app.description" style="background: white" :class="{empty: !app.description}"/>
      </div>

      <hr>

      <p><strong>Obs: </strong>As imagem devem ser da proporção 16x9</p>

      <div class="form-group" v-for="number in numbers" :key="number">
        <label for="">Imagem {{ number }}</label>

        <label v-if="app[`${number}Image`]" class="form-control">
          Nome do arquivo: {{ app[`${number}Image`].name }}
        </label>

        <template v-else>
          <Upload :is-multiple="false" :accept="'.jpeg, .png'" @changeFiles="setImage(number, $event)">
            <p>Selecione a imagem {{ number }}</p>
          </Upload>
        </template>
      </div>

      <hr>

      <div class="row">
        <div class="col-md-12">
          <button @click="openEditor = false" class="btn btn-outline-red mr-2">Fechar</button>
          <button @click="clean()" class="btn btn-outline mr-2">Limpar</button>
          <button @click="save()" class="btn btn-primary">Salvar</button>
        </div>
      </div>

    </div>

    <div v-if="!openEditor" class="toggle-edit">
      <EditIcon size="3x" @click="openEditor = true"/>
    </div>

    <div class="ibox my-5 mx-4">
      <div class="ibox-title">
        <h3>Serviço do App {{ app.nickname || app.name }}</h3>
      </div>
      <div class="ibox-content mx-1">
        <table class="table">
          <thead>
            <tr>
              <th>id</th>
              <th>Nome</th>
              <th>Descrição</th>
              <th>Habilitado por padrão?</th>
              <th>Criado em</th>
              <th>Atualizado em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <Service :service="service" v-for="service in app.services" :key="service.id"/>
          </tbody>
        </table>
      </div>
    </div>

  </div>

</template>

<script>
  import Editor from '@/components/shares/Editor'
  import Form from '@/components/apps/Form'
  import GetAccountApps from '@/mixins/GetAccountApps'
  import ModelMapper from '@/mixins/ModelMapper'
  import Upload from '@/components/shares/specialTag/Upload'
  import Service from '@/components/admin/apps/Service'
  import { EditIcon } from 'vue-feather-icons'

  export default {
    components: { EditIcon, Editor, Form, Service, Upload },
    computed: {
      app() {
        return this.getModel || {}
      }
    },
    created() {
        this.asyncTemplateShow(this.id, {
          after: ({model}) => {
            this.appClone = JSON.stringify(model)
          }
        })
    },
    data() {
      return {
        appClone: '',
        modelPathPrefix: 'admin',
        nameModel: 'App',
        numbers: ['first', 'second', 'third'],
        openEditor: false,
        optionsIcon: ['BookIcon', 'EditIcon', 'FileTextIcon', 'InfoIcon', 'MailIcon']
      }
    },
    methods: {
      buildData() {
        let formData = new FormData()
        let app = this.$parse.toSnakecase(this.app)
        Object.keys(app).forEach(key=> {
          if (app[key]) formData.append(key, app[key])
        })
        return formData
      },
      buildHeaders() {
        return { 'Content-Type': 'multipart/form-data' }
      },
      clean() {
        this.setModel(JSON.parse(this.appClone))
        this.openEditor = false
      },
      save() {
        this.asyncTemplateSave(this.app, {
          after: ({model}) => {
            this.$notify.add( 'App salvo!')
            this.appClone = JSON.stringify(model)
            this.openEditor = false
            this.loadAppsAndAccountApps()
          }
        })
      },
      setImage(number, files) {
        this.$set(this.app, `${number}Image`, files[0])
      },
    },
    mixins: [ModelMapper, GetAccountApps],
    name: 'AdminAppShow',
    props: {
      id: { required: false }
    }
  }
</script>

<style scoped>

  .show-app {
    color: black;
    position: relative;
    height: 100%;
  }

  .toggle-edit {
    color: red;
    position: fixed;
    bottom: 20px;
    right: 20px;
    padding: 8px;
    border-radius: 10px;
    border: solid 1px red;
  }

  .toggle-edit svg {
    cursor: pointer;
  }

  .editor {
    width: 60%;
    background: #8A9EB5;
    position: absolute;
    top: 0;
    right: 0;
    transition-duration: 0.5s;
    transition-property: width, height, opacity;
    transition-timing-function: ease;
  }

  .close-editor {
    width: 0;
    max-height: 100%;
    opacity: 0;
    overflow: hidden;
  }

  .empty {
    border: solid red 1px;
  }

</style>
